import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class AggregrationRerunService {

  constructor(private http: HttpClient) { }

  // 🚀 CRITICAL: Following fir163jsync service pattern exactly
  reRunAggEntities(
    baseUrl: string,
    returnClobSettingsObj: any,
    ecSaveDtls: any[],
    type: string,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // 🚀 CRITICAL: URL construction with action codes like AngularJS service
    let actionCode = '';
    let processName = '';
    
    if (type === 'aggRerun') {
      actionCode = 'nllr6f';
      processName = 'Rerun Aggregation Entities';
    } else if (type === 'consolCalcSchJ') {
      actionCode = 'zo8k0k';
      processName = 'Rerun Consol Calc Sch J';
    } else if (type === 'consolCalcCredits') {
      actionCode = 'zo8k0k';
      processName = 'Rerun Consol Calc Credits';
    } else if (type === 'aggSecondaryAction') {
      actionCode = '4sh9u1';
      processName = 'Secondary Action Entities';
    }
    
    const url = `${baseUrl}/saveJsonObject?action_code=${actionCode}`;

    // 🚀 CRITICAL: Build AngularJS-compatible payload structure
    // NOTE: globalService IS already GlobalService.globalParams (not GlobalService itself)
    let params: any = _.merge({}, globalService || {}, filterParams);
    
    // Build clob_settings from returnClobSettingsObj
    const clobSettings: any = {
      sso_id: returnClobSettingsObj?.sso_id || globalService?.sso_id || '',
      combination_key: returnClobSettingsObj?.combination_key || ''
    };
    
    // Build JSON objects exactly like AngularJS service
    const jsonObj = JSON.stringify(ecSaveDtls || []);
    const jsonSettings = JSON.stringify(clobSettings);
    
    // Extend with clob_data and clob_settings
    params = _.extend({ clob_data: jsonObj }, params);
    params = _.extend({ clob_settings: jsonSettings }, params);
    
    // 🚀 CRITICAL: Add required configuration parameters with proper fallbacks
    // globalService IS globalParams directly, so access .scenario not .globalParams.scenario
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || rowData?.TAX_YEAR || new Date().getFullYear();
    params.scenario = filterParams?.scenario || globalService?.scenario || rowData?.SCENARIO;
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || rowData?.JCD_KEY || 250;
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || 'N';
    params.screen_key = filterParams?.screen_key || globalService?.screen_key || '';
    params.combination_key = returnClobSettingsObj?.combination_key || '';
    params.sso_id = returnClobSettingsObj?.sso_id || '';
    
    // Set process_name based on type
    params.process_name = processName;

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }

  // 🚀 CRITICAL: Secondary action method (separate from main rerun)
  reRunAggSecondaryEntities(
    baseUrl: string,
    returnClobSettingsObj: any,
    ecSaveDtls: any[],
    type: string,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    const url = `${baseUrl}/saveJsonObject?action_code=4sh9u1`;

    // 🚀 CRITICAL: Build AngularJS-compatible payload structure
    // NOTE: globalService IS already GlobalService.globalParams (not GlobalService itself)
    let params: any = _.merge({}, globalService || {}, filterParams);
    
    // 🚀 CRITICAL: Add required configuration parameters with proper fallbacks
    // globalService IS globalParams directly, so access .scenario not .globalParams.scenario
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || rowData?.TAX_YEAR || new Date().getFullYear();
    params.scenario = filterParams?.scenario || globalService?.scenario || rowData?.SCENARIO;
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || rowData?.JCD_KEY || 250;
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || 'N';
    params.screen_key = filterParams?.screen_key || globalService?.screen_key || '';
    params.combination_key = returnClobSettingsObj?.combination_key || '';
    params.sso_id = returnClobSettingsObj?.sso_id || '';
    params.process_name = 'Secondary Action Entities';

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }

  // 🚀 CRITICAL: Fetch max count entities method
  fetchMaxCountEntities(
    baseUrl: string,
    screenKey: string,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    const url = `${baseUrl}/loadJsonObject`;

    // 🚀 CRITICAL: Build AngularJS-compatible payload structure
    // NOTE: globalService IS already GlobalService.globalParams (not GlobalService itself)
    let params: any = _.merge({}, globalService || {}, filterParams);
    
    // 🚀 CRITICAL: Add required configuration parameters with proper fallbacks
    // globalService IS globalParams directly, so access .scenario not .globalParams.scenario
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || rowData?.TAX_YEAR || new Date().getFullYear();
    params.scenario = filterParams?.scenario || globalService?.scenario || rowData?.SCENARIO;
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || rowData?.JCD_KEY || 250;
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || 'N';
    params.screen_key = screenKey || globalService?.screen_key || '';
    params.action_code = 'mysfkb';

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}
